import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  Layout,
  LayoutHeader,
  LayoutContent,
} from "@jana-technology/platform-ui";

import { NavbarContainer, RiskManagementNavTabs } from "components/navbar";
import { RiskSidebar } from "components/sidebar";
import { RiskManagementFiltersProvider } from "contexts/filters/risk-management-filters";
import { OutcomeScenariosProvider } from "contexts/scenarios";

export const RiskManagementLayout = () => {
  const { pathname } = useLocation();
  // ref to capture boundary of LayoutContent for risk filter dropdown positioning
  const [collisionBoundary, setCollisionBoundary] =
    useState<HTMLDivElement | null>(null);

  return (
    <RiskManagementFiltersProvider>
      <OutcomeScenariosProvider>
        <Layout>
          <LayoutHeader>
            <NavbarContainer>
              <RiskManagementNavTabs />
            </NavbarContainer>
          </LayoutHeader>
          <div ref={setCollisionBoundary}>
            <LayoutContent
              key={pathname}
              sidebar={<RiskSidebar collisionBoundary={collisionBoundary} />}
              sidebarSize="sm"
              sidebarCollapsible
            >
              <Outlet />
            </LayoutContent>
          </div>
        </Layout>
      </OutcomeScenariosProvider>
    </RiskManagementFiltersProvider>
  );
};

export default RiskManagementLayout;
